import type { PresentationTicker } from "./PresentationTicker";

/** A count-down on the ticker: `done` resolves when it runs out; `cancel` stops it (and `done` never resolves). */
export interface TimerSleep {
  readonly done: Promise<void>;
  cancel(): void;
}

/**
 * Engine-time sleeps: counts
 * down on the presentation ticker, so it pauses and frame-steps with it and
 * never desyncs from tweens (they share the same tick).
 */
export class PresentationTimerDriver {
  public constructor(public readonly ticker: PresentationTicker) {}

  public sleep(seconds: number): TimerSleep {
    if (seconds <= 0) return { done: Promise.resolve(), cancel: () => {} };
    let unsubscribe: () => void = () => {};
    const done = new Promise<void>((resolve) => {
      let remaining = seconds;
      unsubscribe = this.ticker.add((delta) => {
        remaining -= delta;
        if (remaining <= 1e-9) {
          unsubscribe();
          resolve();
        }
      });
    });
    return { done, cancel: () => unsubscribe() };
  }
}
